export const environment = {
    production: false,
    APIUrl: "https://uatapi.bimag.in/adminapi/api/",
    WebPortalAPIUrl: "https://uatapi.bimag.in/portalapi/api/",
    ReferralUrl: "https://bimaG.in/referral/$uniqueUserId"
  }